import { useEffect, useState } from 'react';
import api from '../utils/api';

let cachedBrands = null;
let inflight = null;

/**
 * Partnered brand names for search empty-state suggestions.
 * Shared cache so header + side panel only hit the API once.
 */
export function usePartneredBrands(limit = 6) {
  const [brands, setBrands] = useState(() =>
    cachedBrands ? cachedBrands.slice(0, limit) : []
  );

  useEffect(() => {
    let cancelled = false;

    const apply = (names) => {
      if (!cancelled) setBrands(names.slice(0, limit));
    };

    if (cachedBrands) {
      apply(cachedBrands);
      return () => { cancelled = true; };
    }

    const load = async () => {
      try {
        if (!inflight) {
          inflight = api.get('/api/products/brands/deal-stats', {
            params: { limit: 12, partnered: true },
          });
        }
        const res = await inflight;
        const names = (Array.isArray(res.data) ? res.data : [])
          .map((b) => b.brand)
          .filter(Boolean);
        cachedBrands = names;
        apply(names);
      } catch (e) {
        console.error('Partnered brands suggestion error:', e);
        inflight = null;
      }
    };

    load();
    return () => { cancelled = true; };
  }, [limit]);

  return brands;
}
